import { useEffect, useState } from 'react';
import PrimaryButton from '../buttons/PrimaryButton';
import './InstallButton.scss';
import SecondaryButton from '../buttons/SecondaryButton';

export default function InstallButton() {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = (e: any) => {
      e.preventDefault();
      setDeferredPrompt(e);

      const dismissedAt = localStorage.getItem('install_prompt_dismissed_at');
      if (dismissedAt) {
        const daysSinceDismissal = (Date.now() - parseInt(dismissedAt, 10)) / (1000 * 60 * 60 * 24);
        if (daysSinceDismissal < 3) {
          return;
        }
      }

      setVisible(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  // dismiss the install prompt
  const handleDismissClick = () => {
    setVisible(false);
    localStorage.setItem('install_prompt_dismissed_at', Date.now().toString());
  };

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;

    setDeferredPrompt(null);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="install-panel">
      <p>Install our app for a better experience</p>
      <PrimaryButton handleOnClick={handleInstallClick}>Install App</PrimaryButton>
      <SecondaryButton handleOnClick={handleDismissClick}>Not now</SecondaryButton>
    </div>
  );
}
